import { Box } from "@mui/material";
import AnalysisInsights from "./analysis-insights";
import AnalysisSummary from "./analysis-summary";

export default function MaterialAnalysisEditor({ metaArtifactData }) {
  return (
    <Box sx={{ height: "100%", overflow: "hidden" }}>
      <Box sx={{ height: "100%", overflowY: "auto" }}>
        <Box sx={{ m: "12px 16px" }}>
          {
            metaArtifactData && <>
              <AnalysisSummary description={metaArtifactData.executionSummary} />
              <AnalysisInsights metaArtifactData={metaArtifactData} />
            </>
          }
        </Box>
      </Box>
    </Box>
  );
}
